module.exports = __webpack_public_path__ + "img/LogoExitusCredit_Color.3e9847ec.png";